// ConsentModal.js
import axios from 'axios';
import React, { useState } from 'react';
import { Modal, Button } from 'react-bootstrap';

const ConsentModal = ({ showModal, handleClose, handleSave , showHolder}) => {

    // State hooks for form fields
    const [modeOfOperation, setModeOfOperation] = useState('Jointly');
    const [communicationReceived, setCommunicationReceived] = useState({
        firstHolder: true,
        allHolder: false,
        secondHolder: false,
        thirdHolder: false,
    });

    // Handle change for the mode of operation radio buttons
    const handleModeChange = (e) => {
        setModeOfOperation(e.target.value);
    };

    // Handle change for the communication received checkboxes
    const handleCommunicationChange = (e) => {
        const { id, checked } = e.target;
        if (id === 'allHolder') {
            const updatedState = Object.keys(communicationReceived).reduce((acc, key) => {
                acc[key] = id === 'allHolder' ? checked : false; // If "All holder" is selected, uncheck and disable others
                return acc;
            }, {});
            setCommunicationReceived(updatedState);
        } else {
            setCommunicationReceived({
                ...communicationReceived,
                allHolder: false, // Uncheck "All holder" if any other option is selected
                [id]: checked,
            });
        }
    };

    // New function to handle API submission
    const handleSubmit = async (isSubmit = true) => {
        const portal_domain = window.sessionStorage.getItem("portal_domain");
        const API_URL = portal_domain
        ? portal_domain.substring(0, portal_domain.length - 1)
        : "";
        const token = window.sessionStorage.getItem("token");
        const headers = {
            headers: {
                "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
                Authorization: `Basic ${token}`,
            },
        };
        const formData = new FormData();
        formData.append('holder', showHolder.toString());
        if(isSubmit){
            formData.append('mode_of_operation', modeOfOperation);
            formData.append('first_holder', communicationReceived.firstHolder ? '1':'0');
            // Include second_holder and third_holder based on showHolder value
            formData.append('second_holder', (communicationReceived.allHolder || communicationReceived.secondHolder) ? '1':'0');
            if (showHolder >= 3) {
                formData.append('third_holder', (communicationReceived.allHolder || communicationReceived.thirdHolder) ? '1':'0');    
            }else{
                formData.append('third_holder', '0');    
            }
        }else{
            formData.append('mode_of_operation', 'Jointly');
            formData.append('first_holder', '1');
            // Include second_holder and third_holder based on showHolder value
            formData.append('second_holder', '0');
            formData.append('third_holder', '0');
        }
        


        try {
            const response = await axios.post(`${API_URL}/api/method/kyc_customizations.apis.joint_holder.update_user_details.endpoint`, formData, headers);
            console.log('API response:', response.data);
            if(response.data){
                handleSave(); // Call the provided handleSave for additional logic
                handleClose();
            }
            
        } catch (error) {
            console.error('API call error:', error);
        }
         // Close modal after submission
    };
    return (
        <Modal size='lg' show={showModal} onHide={handleClose} backdrop="static" keyboard={false}>
            <Modal.Body>
                <div className='border border-dark rounded p-2'>Mode of Operation for execution of transaction (Transfer, Pledge & Freeze)</div>
                <div className='mt-2'></div>
                <div className='row'>
                    <div className='col-md-6'>
                        <div className="form-check">
                            <input className="form-check-input" type="radio" name="modeOfOperation" id="jointly" value="Jointly" onChange={handleModeChange} checked={modeOfOperation === 'Jointly'} />
                            <label className="form-check-label" for="jointly">
                                Jointly
                            </label>
                        </div>
                    </div>
                    <div className='col-md-6'>
                        <div className="form-check">
                            <input className="form-check-input" type="radio" name="modeOfOperation" id="anyOfTheHolder" value="Any of the holder" onChange={handleModeChange} checked={modeOfOperation === 'Any of the holder'}/>
                            <label className="form-check-label" for="anyOfTheHolder">
                                Any of the holder
                            </label>
                        </div>
                    </div>
                </div>
                <div className='mt-4'></div>
                <div className='border border-dark rounded p-2'>
                    <div>Consent of communication to be received by first holder / all account holder</div>
                    <small className='text-danger text-sm'>Tick applicable. If not marked than default option would be <strong>First Holder</strong></small>
                </div>
                <div className='mt-2'></div>
                <div className='row'>
                    <div className='col-md-6'>
                        <div className="form-check">
                            <input className="form-check-input" type="checkbox" name="communicationRecieved" id="firstHolder" value="First holder" onChange={handleCommunicationChange} checked={communicationReceived.firstHolder} disabled={communicationReceived.allHolder}/>
                            <label className="form-check-label" for="firstHolder">
                                First holder
                            </label>
                        </div>
                    </div>
                    <div className='col-md-6'>
                        <div className="form-check">
                            <input className="form-check-input" type="checkbox" name="communicationRecieved" id="allHolder" value="All holder" onChange={handleCommunicationChange} checked={communicationReceived.allHolder} />
                            <label className="form-check-label" for="allHolder">
                                All holder
                            </label>
                        </div>
                    </div>
                     <div className='col-md-6'>
                        <div className="form-check">
                            <input className="form-check-input" type="checkbox" name="communicationRecieved" id="secondHolder" value="Second holder" onChange={handleCommunicationChange} checked={communicationReceived.secondHolder} disabled={communicationReceived.allHolder}/>
                            <label className="form-check-label" for="secondHolder">
                                Second holder
                            </label>
                        </div>
                    </div>
                    {showHolder == 3 &&<div className='col-md-6'>
                        <div className="form-check">
                            <input className="form-check-input" type="checkbox" name="communicationRecieved" id="thirdHolder" value="Third holder" onChange={handleCommunicationChange} checked={communicationReceived.thirdHolder} disabled={communicationReceived.allHolder} />
                            <label className="form-check-label" for="thirdHolder">
                                Third holder
                            </label>
                        </div>
                        </div>
                    }
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="success" onClick={() => handleSubmit(true)}>
                    Save
                </Button>
                <Button variant="danger" onClick={() => handleSubmit(false)}>
                    Cancel
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default ConsentModal;
